module.exports = __webpack_public_path__ + "static/media/Before - A@2x.cc7688bd.jpg";